import * as React from 'react';
import { IconExternalOutlined } from '@repo/monochrome-icons';
import styles from './compare-plans-link.module.css';

interface ComparePlansLinkProps {
  text: string;
  href: string;
}

export function ComparePlansLink({ text, href }: ComparePlansLinkProps): React.ReactNode {
  return (
    <div className={styles.container}>
      <a className={styles.link} href={href} rel="noopener noreferrer" target="_blank">
        <span className="body-standard">{text}</span>
        <IconExternalOutlined height={16} width={16} />
      </a>
    </div>
  );
}
